import { render } from "./IconCurrencyExchangeMenu.vue?vue&type=template&id=7efa09f1"
import script from "./IconCurrencyExchangeMenu.vue?vue&type=script&lang=js"
export * from "./IconCurrencyExchangeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconCurrencyExchangeMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7efa09f1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7efa09f1', __exports__)) {
    api.reload('7efa09f1', __exports__)
  }
  
  module.hot.accept("./IconCurrencyExchangeMenu.vue?vue&type=template&id=7efa09f1", () => {
    api.rerender('7efa09f1', render)
  })

}


export default __exports__